import { useMemo } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

/**
 * Plain rich-text editor — no image handling.
 *
 * Deliberately not EmailBodyEditor: that one exists for its image uploader,
 * which posts to the email app's media endpoint and carries advice about Gmail
 * clipping. Neither applies to a release note, and the image button is left off
 * the toolbar rather than left in, because Quill's default embeds a picked file
 * as a base64 data: URI — that would land a multi-megabyte string in the
 * release body and then ship it to every user in the acknowledgement popup.
 *
 * Output is HTML. It is sanitized server-side on write
 * (platform_core/releases/sanitize.py), which is what makes it safe to render.
 */
export default function RichTextEditor({ value, onChange, height = 220, placeholder }) {
  // Memoised: a fresh `modules` object on every render tears down and rebuilds
  // the Quill instance, losing the cursor position and the undo history.
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [2, 3, false] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote", "link"],
        ["clean"],
      ],
      clipboard: { matchVisual: false },
    }),
    []
  );

  return (
    <div className="release-editor border border-gray-300 dark:border-gray-600 rounded-md overflow-hidden">
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={modules}
        placeholder={placeholder}
        style={{ height }}
      />
    </div>
  );
}
